/**
 * Concierge partner catalogue.
 *
 * Every entry has BOTH a local `image_asset` path (relative to
 * `/frontend/public/`) AND a verified Pexels fallback URL. The tile tries
 * the local file first — the moment you drop an image with the matching
 * name into that folder the local file takes over, no code change needed.
 *
 * Fuel is intentionally a single generic tile (fuel-nozzle photo) with a
 * text list of preferred brands — no per-brand imagery, no brand marks
 * reproduced.
 */
const PX = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=800`;

export const CONCIERGE = {
  fuel: {
    display_name: "Fuel",
    // Single generic image for fuel — text list of accepted stations
    hero: {
      image_asset: "/assets/images/concierge/fuel_station_nozzle.jpg",
      fallback:    PX(4489761),
    },
    description: "Preferred fuel station · voucher redeemable at Shell, BP, Sasol, Engen or Total",
    stations: ["Shell", "BP", "Sasol", "Engen", "Total"],
    tint: "#0F1E3D",
  },
  game_park_visit: {
    display_name: "Game Park Visit",
    description: "Complimentary day pass to one of South Africa's flagship game reserves. The concierge team arranges entry, transfers on request, and confirms availability at your chosen park.",
    hero: { image_asset: "/assets/images/concierge/game_parks/hero.jpg", fallback: PX(1054655) },
    tint: "#0F3D1E",
    partners: [
      { id: "kruger",      name: "Kruger National Park" },
      { id: "pilanesberg", name: "Pilanesberg Game Reserve" },
      { id: "addo",        name: "Addo Elephant Park" },
      { id: "hluhluwe",    name: "Hluhluwe-iMfolozi" },
    ],
  },
  grocery_voucher: {
    display_name: "Grocery Voucher",
    description: "Prepaid grocery voucher redeemable at your preferred supermarket. The concierge team issues the voucher within 24 h to the mobile number linked to your account.",
    hero: { image_asset: "/assets/images/concierge/groceries/hero.jpg", fallback: PX(264636) },
    tint: "#7A0019",
    partners: [
      { id: "woolworths", name: "Woolworths" },
      { id: "pick_n_pay", name: "Pick n Pay" },
      { id: "checkers",   name: "Checkers" },
      { id: "shoprite",   name: "Shoprite" },
      { id: "spar",       name: "Spar" },
    ],
  },
  car_wash: {
    display_name: "Car Wash",
    description: "One complimentary full-service car wash at a partner facility of your choice. The concierge team confirms your booking within 24 h.",
    hero: { image_asset: "/assets/images/concierge/carwash/hero.jpg", fallback: PX(1149831) },
    tint: "#003C4B",
    partners: [
      { id: "carwashhub", name: "Carwashhub" },
      { id: "bubbles",    name: "Bubbles" },
      { id: "pitstop",    name: "Pitstop Wash" },
    ],
  },
  car_service: {
    display_name: "Car Service",
    description: "Complimentary car service (oil, filters, safety check) at your preferred workshop. The concierge team schedules the booking and forwards confirmation.",
    hero: { image_asset: "/assets/images/concierge/car_service/hero.jpg", fallback: PX(3806249) },
    tint: "#1F2937",
    partners: [
      { id: "supa_quick",  name: "Supa Quick" },
      { id: "tiger_wheel", name: "Tiger Wheel" },
      { id: "midas",       name: "Midas" },
      { id: "bosch",       name: "Bosch Service" },
    ],
  },
  hotel_stay: {
    display_name: "Hotel Stay",
    description: "Discounted stay at a curated network of South African hotels. Rate depends on availability; concierge confirms your dates and forwards booking reference.",
    hero: { image_asset: "/assets/images/concierge/hotels/hero.jpg", fallback: PX(258154) },
    tint: "#4A2C0A",
    partners: [
      { id: "southern_sun",      name: "Southern Sun" },
      { id: "sun_international", name: "Sun International" },
      { id: "radisson_blu",      name: "Radisson Blu" },
      { id: "city_lodge",        name: "City Lodge" },
    ],
  },
};
